module.exports = __webpack_public_path__ + "static/images/styles/images/pure-table/pattern.1aced791.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/pure-table/pattern.png
// module id = 3681
// module chunks = 11